import { FC, ReactNode } from "react";

import { Icon, IconName, Panel, Tooltip } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import "./ComparePlansPage.scss";

interface TileProps {
  iconName?: IconName;
  title?: string;
  titleTooltip?: string;
  description?: string;
  children?: ReactNode;
}

export const HeadingTile: FC<TileProps> = ({ iconName, title, titleTooltip, description, children }) => {
  return (
    <Panel className="heading-tile" appearance="secondary">
      <Stack spacing="small">
        {iconName && <Icon name={iconName}></Icon>}
        {title &&
          <Semibold>
            {title}
            {titleTooltip && <Tooltip content={titleTooltip}>
              {(ref) => (
                <span ref={ref}>
                  <Icon size="small" name="info-circle" />
                </span>
              )}
            </Tooltip>}
          </Semibold>
        }
        {description && <Body>{description}</Body>}
        {children}
      </Stack>
    </Panel>
  );
};
